import { ShieldCheck, KeyRound, Lock, Database, Network, HardDriveDownload, Activity, BadgeCheck, ScrollText, RefreshCw } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const ITEMS = [
  { icon: KeyRound, label: "Secure Authentication" },
  { icon: ShieldCheck, label: "Role-Based Access" },
  { icon: Lock, label: "HTTPS / SSL" },
  { icon: Database, label: "Data Isolation" },
  { icon: Network, label: "Secure API Architecture" },
  { icon: HardDriveDownload, label: "Database Backups" },
  { icon: Activity, label: "Monitoring" },
  { icon: BadgeCheck, label: "Payment Verification" },
  { icon: ScrollText, label: "Audit Logs" },
  { icon: RefreshCw, label: "Regular Updates" },
];

export const Security = () => (
  <section id="security" className="bg-mist py-24 sm:py-32" data-testid="security-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">
        <Reveal>
          <Eyebrow>Security</Eyebrow>
          <h2 className="mt-5 font-jakarta text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl" data-testid="security-heading">
            Built With Security in Mind
          </h2>
          <p className="mt-5 max-w-md font-inter text-[15px] leading-relaxed text-slate-500">
            Security is engineered into every RCS product from day one — not added as an afterthought.
            From access control to encrypted transport and verified payments, the fundamentals are always covered.
          </p>
        </Reveal>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-2 xl:grid-cols-3">
          {ITEMS.map((item, i) => (
            <Reveal key={item.label} delay={(i % 3) * 0.07}>
              <div
                className="group flex h-full items-center gap-3 rounded-lg border border-slate-200 bg-white px-4 py-4 transition-[border-color,transform] duration-300 hover:-translate-y-0.5 hover:border-gold/50"
                data-testid={`security-item-${i + 1}`}
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-mist text-navy ring-1 ring-slate-200 transition-colors duration-300 group-hover:bg-gold group-hover:text-white group-hover:ring-gold">
                  <item.icon className="h-4 w-4" />
                </span>
                <span className="font-jakarta text-[12.5px] font-semibold leading-tight text-navy">{item.label}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
